import React from "react";
import PageTitle from "../common/PageTitle/PageTitle";
import ParaTitle from "../common/ParaTitle/ParaTitle";
import { Paragraph, ParaImageDialog, ParaSubtitle, Pagination } from "../common";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

const EventsSummary = () => {
  return (
    <div>
      <PageTitle title='Event Summary' role='Any' />
      <ParaTitle paraTitle='Event Naming' />
      <Paragraph paragraph='Events are named by their ID. The first leter corresponds to the event type ("U" - Unsafe Condition, "N" - near miss, "I" - Incident). The rest of the ID is generated automatically.' />
      <ParaTitle paraTitle='Which events can you access?' />
      <Paragraph paragraph='To see the events that you can access simply login and look at your dashboard. Each tab in the dashboard contains a list of events that you can view. This varies greatly by role. For the role "User" this will only include event drafts but for the role "Admin" this will include every type of event.' />
      <Paragraph paragraph='A User dashboard:' />
      <ParaImageDialog src="/tutorial_image/events-summary-1.png" />
      <Paragraph paragraph='An Admin dashboard:' />
      <ParaImageDialog src="/tutorial_image/events-summary-2.png" />

      <ParaTitle paraTitle='Event Summary' />
      <Paragraph paragraph='Most event IDs can be clicked on to take a user to the Event Summary page. Note that events in the draft stage do not have an event summary. Event summary displays a detailed report which includes all information for the event ID shown at the top.' />
      <ParaSubtitle paraSubtitle='Event Information' />
      <Paragraph paragraph='All events have information that comes with them. This consists of:' />
      <ol>
        <Typography variant="body1" component="li">Reviewers assigned to the event</Typography>
        <Typography variant="body1" component="li">Comments associated with the event</Typography>
        <Typography variant="body1" component="li">Files uploaded to the event</Typography>
        <Typography variant="body1" component="li">Linked events</Typography>
      </ol>
      <Paragraph paragraph='This information is viewable depending on your role and the status of the event. Read about event statuses here. A sample event summary is shown below.' />
      <ParaImageDialog src='/tutorial_image/events-summary-3.png' />
      <Paragraph paragraph='The information pertaining to an event can be modified depending on your role.' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        Click on the "Actions" button in the top right to see options related to reviewing, approving, editing, or deleting an event. The options that show are dependent on the status of the event. Read about <Link to='/general/event-status'>Event Statuses</Link>.
      </Typography>
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        Click on "Reviews" tab, if available, to see "Available Reviewers" who can be assigned to an event/record. Please read more under <Link to='/risk-manager/assign-reviewers'>Assign Reviewers</Link> of the tutorial.
      </Typography>

      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        Click on "Add/View Comments" tab to add comments to the record. Please read more under <Link to='/risk-manager/add-view-comments'>Add/View Comments</Link> of the tutorial.
      </Typography>

      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        Click on "Add/View Uploads" to upload files to the record. Please read more under <Link to='/risk-manager/add-view-uploads'>Add/View Uploads</Link> of the tutorial.
      </Typography>

      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        Click on "Linked Events" to link another event. Please read more under <Link to='/risk-manager/linked-events'>Linked Events</Link> of the tutorial.
      </Typography>
      <ParaSubtitle paraSubtitle='Private Message' />
      <Paragraph paragraph='Messages are linked to the events they are associated with, ensuring that all conversations remain within their respective events. To view a private conversation between an individual and an involved person (e.g., approver, reviewer, risk manager, etc.), the user can navigate to the "Comments" section and select the relevant individual. A count next to the individual’s name indicates the number of active conversations. If the count is 0, no messages have been exchanged with that person. Below is an example screenshot:' />
      <ParaImageDialog src='/tutorial_image/events-summary-4.png' />

      <Pagination
                pagination={{
                    prev: { name: 'Updates: 3.53.0', link: '/updates/3.53.0' },
                    next: { name: 'Event Status', link: '/general/event-status' }
                }}
            />
    </div>
  );
};

export default EventsSummary;
